var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('iframe',{ref:"childFrame",staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":_vm.childProjectUrl},on:{"load":_vm.onIframeLoad}}),_vm._v(" "),(!_vm.hideMask)?_c('div',{staticClass:"box-mask"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11849ab8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/screen-3d/screen-3d.vue
// module id = null
// module chunks = 